import { render } from "./EquipmentPage.vue?vue&type=template&id=279b8c54&scoped=true"
import script from "./EquipmentPage.vue?vue&type=script&lang=js"
export * from "./EquipmentPage.vue?vue&type=script&lang=js"

import "./EquipmentPage.vue?vue&type=style&index=0&id=279b8c54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279b8c54"]])

export default __exports__